import { useApp } from "@/store/AppStore";
import { MONTHS } from "@/utils/format";

const PeriodBar = () => {
  const { data, setPeriod } = useApp();
  const currentYear = new Date().getFullYear();
  const years = [currentYear - 1, currentYear, currentYear + 1, currentYear + 2];

  const selectClass =
    "appearance-none bg-background-200/60 border border-accent-500/20 rounded-md pl-8 pr-8 py-2 text-xs md:text-sm font-medium text-foreground-900 cursor-pointer hover:border-accent-500/40 focus:outline-none focus:ring-2 focus:ring-accent-500/40";

  return (
    <div className="flex items-center gap-2">
      <div className="relative">
        <span className="pointer-events-none absolute left-2.5 top-1/2 -translate-y-1/2 w-4 h-4 flex items-center justify-center text-accent-300">
          <i className="ri-calendar-line text-sm" />
        </span>
        <select
          value={data.period.year}
          onChange={(e) => setPeriod({ ...data.period, year: Number(e.target.value) })}
          className={selectClass}
          aria-label="Año"
        >
          {years.map((y) => (
            <option key={y} value={y} className="bg-background-100">
              {y}
            </option>
          ))}
        </select>
        <span className="pointer-events-none absolute right-2 top-1/2 -translate-y-1/2 w-4 h-4 flex items-center justify-center text-foreground-500">
          <i className="ri-arrow-down-s-line" />
        </span>
      </div>

      <div className="relative">
        <span className="pointer-events-none absolute left-2.5 top-1/2 -translate-y-1/2 w-4 h-4 flex items-center justify-center text-accent-300">
          <i className="ri-filter-3-line text-sm" />
        </span>
        <select
          value={String(data.period.month)}
          onChange={(e) =>
            setPeriod({
              ...data.period,
              month: e.target.value === "anual" ? "anual" : Number(e.target.value),
            })
          }
          className={selectClass}
          aria-label="Mes"
        >
          {MONTHS.map((m, i) => (
            <option key={m} value={i} className="bg-background-100">
              {m}
            </option>
          ))}
          <option value="anual" className="bg-background-100">
            Consolidado Anual
          </option>
        </select>
        <span className="pointer-events-none absolute right-2 top-1/2 -translate-y-1/2 w-4 h-4 flex items-center justify-center text-foreground-500">
          <i className="ri-arrow-down-s-line" />
        </span>
      </div>
    </div>
  );
};

export default PeriodBar;